// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__x-fRB","list":"PatternAutocomplete_list__10VAJ"};